import $api from "@/core/services/ApiService";
import { AxiosResponse } from "axios";
import { PspPortalRegistration } from "@/core/services/api/interfaces/manager/Company";

class FlexpspEndpoint {
  public registration(form: PspPortalRegistration): Promise<AxiosResponse> {
    return $api.post("manager/flexpsp/sign-up", form);
  }

  public upsertAccounts(data): Promise<AxiosResponse> {
    return $api.post("manager/flexpsp/accounts", data);
  }

  public listAccounts(): Promise<AxiosResponse> {
    return $api.get("manager/flexpsp/accounts");
  }

  public revokeToken(): Promise<AxiosResponse> {
    return $api.post("manager/flexpsp/revoke-token");
  }

  public viewPayment(payment_id: string): Promise<AxiosResponse> {
    return $api.get(`manager/flexpsp/payments/${payment_id}`);
  }
}

export default FlexpspEndpoint;
